export default "__VITE_ASSET__ksevxGOG__"